import './App.css';
import {Route, Routes} from "react-router-dom"
import Policy from './policy';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Policy name="Nivo"/>}/>
      <Route path="/ace" element={<Policy name="Ace Solutions"/>}/>
      <Route path="/autarky" element={<Policy name="Autarky"/>}/>
      <Route path="/cls" element={<Policy name="CLS Money"/>}/>
      <Route path="/coop" element={<Policy name="The Co-operative Bank Business Help"/>}/>
      <Route path="/crystal" element={<Policy name="Crystal Specialist Finance"/>}/>
      <Route path="/evolution" element={<Policy name="Evolution Money"/>}/>
      <Route path="/loanable" element={<Policy name="Loanable"/>}/>
      <Route path="/love" element={<Policy name="Love Finance"/>}/>
      <Route path="/mfs" element={<Policy name="Market Financial Solutions"/>}/>
      <Route path="/me" element={<Policy name="Mortgage Experience"/>}/>
      <Route path="/mortgagehut" element={<Policy name="Mortgage Hut"/>}/>
      <Route path="/ocean" element={<Policy name="Ocean"/>}/>
      <Route path="/pepper" element={<Policy name="Pepper"/>}/>
      <Route path="/sbs" element={<Policy name="Scottish Building Society"/>}/>
      <Route path="/selina" element={<Policy name="Selina Finance"/>}/>
      <Route path="/sercle" element={<Policy name="Sercle"/>}/>
      <Route path="/stepone" element={<Policy name="Step One"/>}/>
      <Route path="/time" element={<Policy name="Time Finance"/>}/>
      <Route path="/together" element={<Policy name="Together Money"/>}/>
      <Route path="/utb" element={<Policy name="United Trust Bank"/>}/>
      <Route path="/atl" element={<Policy name="ATL Global"/>}/>
      <Route path="/accredo" element={<Policy name="Accredo"/>}/>
      <Route path="/smcu" element={<Policy name="South Manchester Credit Union"/>}/>
      <Route path="/propp" element={<Policy name="Propp"/>}/>
      <Route path="/firenze" element={<Policy name="Firenze"/>}/>
      <Route path="/ccbank" element={<Policy name="Cambridge and Counties Bank"/>}/>
      <Route path="/ethos" element={<Policy name="Ethos Assest Finance"/>}/>
      <Route path="/mercantile" element={<Policy name="Mercantile Trust"/>}/>
      <Route path="/binq" element={<Policy name="Binq"/>}/>
      <Route path="/hopecapital" element={<Policy name="Hope Capital"/>}/>
      <Route path="/greenwood" element={<Policy name="Greenwood Capital"/>}/>
      <Route path="/artoriusadvance" element={<Policy name="Artorius Advance"/>}/>
      <Route path="/mykis" element={<Policy name="My Kis Finance"/>}/>
      <Route path="/leonardcurtis" element={<Policy name="Leonard Curtis Funding"/>}/>
      <Route path="/aromoney" element={<Policy name="Aro Money"/>}/>
      <Route path="/morpheus" element={<Policy name="Morpheus"/>}/>
    </Routes>
  );
}

export default App;
